import { RoomType } from "building-types/rooms/roomTypesEnum";
import { defaultRoomCatalog } from "./roomCatalog";

const inspectorRoomTypes = Object.values(RoomType)
  .filter((t) => !defaultRoomCatalog[t].hiddenInEditor)
  .sort();

export default inspectorRoomTypes;
